import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-rounded"
}
const _hoisted_2 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "rounded-container",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPress && _ctx.onPress(...args)))
  }, [
    (this.text)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(this.text), 1))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.loadMyAccount,
          class: "icon",
          alt: _ctx.$t('alt.mon.compte')
        }, null, 8, _hoisted_2))
  ]))
}